import logout from './logout';

export default logout;
